import LockOutlined from "@ant-design/icons/LockOutlined";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AuthWrapper from "components/layout/login/AuthWrapper";
import LogoSection from "components/logo";
import { useState } from "react";
import { useAuthContext } from "~/common/hooks/useAuthContext";

export default function LoginPage() {
  const auth = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      setError(null);
      await auth.signinRedirect();
    } catch (err) {
      console.error("Login error:", err);
      setError("Failed to redirect to login. Please try again.");
      setIsLoading(false);
    }
  };

  if (auth.isLoading) {
    return (
      <AuthWrapper>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress size={60} />
        </Box>
      </AuthWrapper>
    );
  }

  if (auth.error) {
    return (
      <AuthWrapper>
        <Alert severity="error">
          Authentication Error:{" "}
          {auth.error.message ||
            "An unknown error occurred. Please try again later."}
        </Alert>
      </AuthWrapper>
    );
  }

  return (
    <AuthWrapper>
      <Stack spacing={3} alignItems="center">
        <LogoSection />
        <Box textAlign="center">
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 600, color: "text.primary" }}
          >
            TobyLabs
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Sign in to access your dashboard
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ width: "100%" }}>
            {error}
          </Alert>
        )}

        <Button
          variant="contained"
          fullWidth
          startIcon={<LockOutlined />}
          onClick={handleLogin}
        >
          {isLoading ? "Redirecting..." : "Sign In"}
        </Button>

        <Typography
          variant="caption"
          color="text.secondary"
          textAlign="center"
          sx={{ mt: 2 }}
        >
          You will be redirected for secure authentication.
        </Typography>
      </Stack>
    </AuthWrapper>
  );
}
